import Initialize from "@/consoleapi/api/initialize";
import Cognito from "@/cognito/cognito";

export default class AuthMypage {

    /**
     * @param bearerToken
     */
    constructor() {
        //this.authenticated(bearerToken);
        //this.getInitialize(bearerToken);
    }

    /**
     * @param userName
     * @param bearerToken
     */
    auth(userName: string, bearerToken: string){
        const cognito = new Cognito();
        cognito.refresh(userName, bearerToken).then(response =>{
            //console.log(response);
        }).catch(error => {
            //console.log(error);
        });
    }

    /**
     * @param bearerToken
     */
    getInitialize(bearerToken: string | null) {
        if (bearerToken === null) {
            throw 'no token found';
        }
        const initialize = new Initialize();
        initialize.setBearerToken(bearerToken);
        return initialize.get();
    }

}